"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRecentSearchUsed = void 0;
const trackRecentSearchUsed = (params) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "recent_search_used",
        query: params.query,
        position: params.position,
        total_recents: params.totalRecents,
    });
};
exports.trackRecentSearchUsed = trackRecentSearchUsed;
